class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    // The search modal is portaled to <body> while open (see open()/close()
    // below) so #shopify-section-header is free to use `transform` for its
    // scroll offset without trapping this in a shrunk containing block.
    // Remember where it actually lives in the markup so close() can put it
    // back exactly where it belongs.
    this.searchModal = this.querySelector('.search-modal');
    if (this.searchModal) {
      this.searchModalHome = {
        parent: this.searchModal.parentNode,
        nextSibling: this.searchModal.nextSibling,
      };
    }

    // Attached to document, not detailsContainer: while open, keyboard focus
    // lives inside .search-modal, which is portaled to <body> (see open()
    // below) and so is no longer a descendant of detailsContainer — a
    // keyup there would never bubble to it.
    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) this.close();
    });
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if( event.target.closest('details').classList.contains("header__search-details")) {

      let menu_drawer = document.getElementById("Details-menu-drawer-container");

      if (menu_drawer && menu_drawer.hasAttribute("open")) {
        let summaryElement = menu_drawer.querySelector("summary");
        if (summaryElement && summaryElement.getAttribute('aria-expanded') === 'true') {
            summaryElement.setAttribute("aria-expanded", false);
            menu_drawer.open = false;
        }
      }
    }
    if (event.target.closest('details').hasAttribute('open')) {
      this.close();
      document.body.classList.remove('overflow-hidden');
    } else {
      this.open(event);
      document.body.classList.add('overflow-hidden');
    }
  }

  onBodyClick(event) {
    const clickedInside =
      this.contains(event.target) ||
      (this.searchModal && this.searchModal.contains(event.target));
    if (!clickedInside || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    if (this.searchModal) {
      document.body.appendChild(this.searchModal);
      this.searchModal.classList.add('search-modal--open');
      const header = document.getElementById('shopify-section-header');
      if (header && header.classList.contains('header-scrolling')) {
        this.searchModal.classList.add('search-modal--scrolled');
      }
    }

    //This resolves an issue with search icon not opening search modal
    //when scrolled down on the page, on windows devices
    if (!navigator.userAgent.includes("Win")) {
      document.body.classList.add('overflow-hidden');
    }

    const focusContainer = this.searchModal || this.detailsContainer;
    trapFocus(
      focusContainer.querySelector('[tabindex="-1"]'),
      focusContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (this.searchModal) {
      this.searchModal.classList.remove('search-modal--open', 'search-modal--scrolled');
      this.searchModalHome.parent.insertBefore(this.searchModal, this.searchModalHome.nextSibling);
    }
  }
}

customElements.define('details-modal', DetailsModal);
